import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import { SegmentedStepper } from '@dev-go4ellis/go4-design-system';
import { trackMixpanelPageView } from 'helpers/post';
import { withQueryParamCapture } from '@helpers/useQueryParamCapture';
import { loadGoogleAdsFromLocalStorage } from '@helpers/localStorage';
import { getReferralCodeWithFallback } from '@helpers/referralHero';
import { update as updateUser } from 'redux/ducks/User';
import AdvancedOptionCard from '../OptionCards/AdvancedOptionCard';
import { getFunnelStepperConfig } from '../funnelSteps';
import './Persona.scss';

// Step six of the updated Job Poster funnel (GO4-1729). The progress stepper is rendered
// centered in the top navigation — see scenes/V3/CreateAccountScene/funnelSteps.

const CONSULTATION_FORM_URL =
  'https://www.go4.io/contract-services-consultation-form-platform/';

const CREATE_JOB_PATH = '/v2/create-event/organization';

const PERSONA_OPTIONS = [
  {
    title: 'One-Time / Per Diem',
    body: 'A single event, game, or shift — post it and get applicants fast.',
    value: 'Single',
  },
  {
    title: 'Recurring',
    body: 'Weekly or monthly coverage on a set schedule.',
    value: 'Recurring',
  },
  {
    title: 'Long-Term Placement',
    body: 'Seasonal, school-year, or full-time — our team will help match you.',
    value: 'Contract',
  },
];

class Persona extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedPersona: null,
    };
  }

  componentDidMount() {
    trackMixpanelPageView('/create-account/persona');
  }

  onSelect = value => () => {
    this.setState({ selectedPersona: value });
    trackMixpanelPageView('/persona_selected', {
      persona: value,
      page: '/create-account/persona',
    });
  };

  onContinue = () => {
    const { selectedPersona } = this.state;
    if (!selectedPersona) return;

    // Persist persona to the user account, along with tracking params
    // (gclid/wbraid/gbraid for Google Ads, mwr referral code via referralHero).
    const googleAdsParams = loadGoogleAdsFromLocalStorage();
    const referral = getReferralCodeWithFallback(this.props.location);

    this.props.updateUser({
      ...this.props.user,
      userPersona: selectedPersona,
      ...googleAdsParams,
      ...(referral && { referral }),
    });

    if (selectedPersona === 'Contract') {
      // Long-Term Placement → consultation form (external).
      // setTimeout gives the PATCH request a chance to fire before the page navigates away.
      trackMixpanelPageView('LongTermForm');
      setTimeout(() => {
        window.location.href = CONSULTATION_FORM_URL;
      }, 300);
      return;
    }

    // One-Time / Recurring → standard create-job pipeline
    this.props.history.push(CREATE_JOB_PATH);
  };

  render() {
    const { selectedPersona } = this.state;
    const buttonDisabled = !selectedPersona;
    const funnelStepper = getFunnelStepperConfig('/create-account/persona');

    return (
      <div className="persona">
        <main>
          {funnelStepper && (
            <div className="next-steps-mobile-stepper">
              <SegmentedStepper total={funnelStepper.total} current={funnelStepper.current} size="sm" />
            </div>
          )}
          <header>
            <div className="screen-title">Great, let's find you an athletic trainer!</div>
            <div className="screen-subtitle">How do you plan to use Go4?</div>
          </header>
          <div className="content">
            <div className="persona-options">
              {PERSONA_OPTIONS.map(({ title, body, value }) => (
                <AdvancedOptionCard
                  key={value}
                  className="persona-option"
                  title={title}
                  body={body}
                  onClick={this.onSelect(value)}
                  selected={selectedPersona === value}
                  inlineArrowOnSelect
                />
              ))}
            </div>
          </div>
        </main>
        <div className="navigation-buttons">
          <Button onClick={this.onContinue} className="continue-button" disabled={buttonDisabled}>
            <div>Continue</div>
          </Button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  authenticated: state.session.authenticated,
  user: state.session.currentUser || state.registration.user,
});

const mapDispatchToProps = dispatch => ({
  updateUser: user => dispatch(updateUser(user)),
});

export default withQueryParamCapture(connect(mapStateToProps, mapDispatchToProps)(Persona));